import { Heading , Img} from "components";
import strings from "locales/en";
import { Link } from "react-router-dom";
export default function Privacy() 
{

    return (
        <>
            <header
            className={`flex justify-start items-center py-6 sm:py-5 bg-white sm:items-start`}>
                <div className="flex items-center gap-[81px] px-4 md:px-5 sm:items-start sm:gap-5">
                    <Link to="/">
                    <Img
                        src="images/img_header_logo.svg"
                        alt="Headerlogo"
                        className="w-[6.4vw] ml-[5vw] md:w-[60px] object-contain sm:h-[32px] sm:w-fit"
                    />
                    </Link>
                </div>
            </header>
            <div className="w-full flex items-center justify-center bg-white mb-10">
                <div className="w-[90vw] flex flex-col items-start justify-start ">
                    <Heading as="h1" className="font-lora text-dark-blue-secondary text-[2.5vw] sm:text-[40px] md:text-[40px] font-bold mt-[16px] mb-[16px]">
                        {strings.en.privacy.title}
                    </Heading>
                    <Heading as="p" noFont={true} className="font-lora text-black-600 text-[18px]">
                        {strings.en.privacy.effectiveDate}
                    </Heading>
                    <Heading as="p" noFont={true} className="font-lora text-black-600 text-[18px]">
                        {strings.en.privacy.lastUpdated}
                    </Heading>
                    <div className="w-full flex flex-col items-start justify-start mt-[2vw]">
                    {strings.en.privacy.articles.map((art, index) => (
                        <div key={index} className="w-full flex flex-col mt-10 items-start justify-start">
                            <Heading
                            noFont={true}
                            as="h2"
                            className="font-lora text-black-600 text-[1.8vw] sm:text-[30px] md:text-[30px] font-bold mt-[16px] mb-[16px]"
                            >
                            {art.title}
                            </Heading>
                            <div className="flex flex-col gap-2">
                            {art.content.split('\n').map((line, i) => (
                                <Heading
                                key={i}
                                noFont={true}
                                as="p"
                                className="font-lora text-black-600 text-[18px]"
                                >
                                {line}
                                </Heading>
                            ))}
                            </div>
                        </div>
                        ))}

                    </div>
                </div>
            </div>
        </>
    )
}